import { Link, useLocation } from 'react-router-dom'
import { StationMark } from './StationMark'

type IndexItem =
  | { href: string; label: string }
  | { to: string; label: string }

const homeIndex: IndexItem[] = [
  { href: '#register', label: 'Engagements' },
  { href: '#legend', label: 'What we build' },
  { href: '#traverse', label: 'How we work' },
  { to: '/compound', label: 'Compound' },
  { href: '#contact', label: 'Contact' },
]

const compoundIndex: IndexItem[] = [
  { href: '#capabilities', label: 'Capabilities' },
  { href: '#industry', label: 'Industry' },
  { href: '#memory', label: 'Memory' },
  { href: '#models', label: 'Plans' },
  { href: '#contact', label: 'Contact' },
]

const legalIndex: IndexItem[] = [
  { to: '/terms', label: 'Terms' },
  { to: '/privacy', label: 'Privacy' },
  { to: '/cookies', label: 'Cookies' },
  { to: '/compound', label: 'Compound' },
]

/** Longitudes across the sheet's top edge, at the real meridians for the emirate. */
const meridians = ['55°30′E', '55°40′E', '55°50′E', '56°00′E', '56°10′E', '56°20′E']

export function SheetHeader() {
  const { pathname } = useLocation()
  const onCompound = pathname.startsWith('/compound')
  const onLegal =
    pathname.startsWith('/terms') ||
    pathname.startsWith('/privacy') ||
    pathname.startsWith('/cookies')
  const index = onLegal ? legalIndex : onCompound ? compoundIndex : homeIndex

  return (
    <header className="sticky top-0 z-50 border-b border-rule bg-sheet">
      <div
        className="hidden items-end justify-between border-b border-rule-faint px-6 pb-1 pt-1.5 md:flex lg:px-8"
        aria-hidden="true"
      >
        {meridians.map((tick) => (
          <span key={tick} className="datum text-ink-muted">
            {tick}
          </span>
        ))}
      </div>

      <div className="mx-auto flex max-w-[100rem] items-center justify-between gap-6 px-6 py-3.5 lg:px-8">
        <Link to="/" className="group flex items-center gap-2.5 text-ink">
          <StationMark className="h-7 w-7 shrink-0 text-overprint" />
          <span
            className="text-xl font-bold uppercase tracking-[0.02em]"
            style={{ fontStretch: '76%' }}
          >
            Passwork
          </span>
        </Link>

        <nav
          className="hidden items-center gap-7 md:flex"
          aria-label="Sheet index"
        >
          {(onCompound || onLegal) && (
            <Link
              to="/"
              className="index-link cell-label text-ink-muted transition-colors hover:text-ink focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-ink"
            >
              Home
            </Link>
          )}
          {index.map((item) =>
            'to' in item ? (
              <Link
                key={`${item.to}-${item.label}`}
                to={item.to}
                className="index-link cell-label text-ink-muted transition-colors hover:text-ink focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-ink"
              >
                {item.label}
              </Link>
            ) : (
              <a
                key={item.href}
                href={item.href}
                className="index-link cell-label text-ink-muted transition-colors hover:text-ink focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-ink"
              >
                {item.label}
              </a>
            ),
          )}
        </nav>

        {onLegal ? (
          <Link to="/privacy" className="cell-label text-overprint md:hidden">
            Privacy
          </Link>
        ) : (
          <a href="#contact" className="cell-label text-overprint md:hidden">
            Contact
          </a>
        )}
      </div>
    </header>
  )
}
